import { Monitor, Moon, Sun } from 'lucide-react';
import { type Theme, useTheme } from '@/lib/theme';

/**
 * Cycle button: light → dark → system → light.
 * Shows the icon for the CURRENT mode; tooltip explains where the next click goes.
 */
const NEXT: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

const LABEL: Record<Theme, string> = {
  light: 'สว่าง',
  dark: 'มืด',
  system: 'ตามระบบ',
};

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
  const next = NEXT[theme];

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={`สลับธีม (ตอนนี้: ${LABEL[theme]} → คลิกเปลี่ยนเป็น ${LABEL[next]})`}
      title={`ธีม: ${LABEL[theme]} (คลิกเป็น ${LABEL[next]})`}
      className="rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-50"
    >
      <Icon className="h-5 w-5" />
    </button>
  );
}
